import { useEffect } from "react";
import { useGetEnabledLocales, type Locale } from "src/api/locales/useLocales";

/**
 * Hook pour synchroniser l'attribut dir du tag HTML avec la direction de la locale courante
 */
export const useDirectionSync = (currentLanguage: string) => {
    const { data: enabledLocales } = useGetEnabledLocales();

    useEffect(() => {
        if (!enabledLocales || !currentLanguage) return;

        const currentLocale = enabledLocales.find((locale: Locale) => locale.code === currentLanguage);
        const direction = currentLocale?.direction || "ltr";
        const htmlElement = document.documentElement;
        htmlElement.setAttribute("dir", direction);
        htmlElement.setAttribute("lang", currentLanguage);
    }, [currentLanguage, enabledLocales]);
};
